
import React, { Suspense, lazy } from "react";
import "./Home.css";

import VideoFirst from "../../component/videofirst/VideoFirst";
import FAQ from "../../component/faq/FAQ";

// Lazy-loaded components
const VideoSecond = lazy(() => import("../../component/videosecond/VideoSecond"));
const AmongTopSolar = lazy(() => import("../../component/amongtopsolar/AmongTopSolar"));
const SolarMod = lazy(() => import("../../component/solarmod/SolarMod"));
const SolarPanel = lazy(() => import("../../component/solarpanel/SolarPanel"));
const Factories = lazy(() => import("../../component/factories/Factories"));
const SliderFirst = lazy(() => import("../../component/sliderfirst/SliderFirst"));
const ContactBox = lazy(() => import("../../component/enquiry/ContactBox"));

function Home() {
  return (
    <>
      <VideoFirst />
      <Suspense
        fallback={
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
            <div className="spinner-border" role="status" style={{color:'#a20000'}}>
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        }
      >
        <VideoSecond />
        <AmongTopSolar />
        <SolarMod />
        <SolarPanel />
        <Factories />
        <SliderFirst />
        <FAQ/>
        <ContactBox />
      </Suspense>
    </>
  );
}

export default Home;
